export enum MemberCategoryType {
    PROFESSOR = 'Professor',
    RESEARCHER = 'Researcher',
    STUDENT = 'Student',
    ALUMNI = 'Alumni',
}
